<template>
  <div class="theme-小蜜通用皮肤1">
    <!-- SVG Icons -->
    <svg xmlns="http://www.w3.org/2000/svg" id="__CHATUI_ICONS__" style="display:none">
      <symbol id="icon-spinner" viewBox="0 0 48 48">
        <path d="M24 2.5a1.5 1.5 0 0 1 0 3C13.783 5.5 5.5 13.783 5.5 24S13.783 42.5 24 42.5 42.5 34.217 42.5 24a1.5 1.5 0 0 1 3 0c0 11.874-9.626 21.5-21.5 21.5S2.5 35.874 2.5 24 12.126 2.5 24 2.5Z"></path>
      </symbol>
      <symbol id="icon-chevron-right" viewBox="0 0 48 48">
        <path d="m35.108 22.619-15.28-14.06a1.5 1.5 0 0 0-2.133 2.106l.101.103 14.836 13.648-14.836 13.649a1.5 1.5 0 0 0-.18 2.008l.092.111a1.5 1.5 0 0 0 2.009.181l.11-.092 15.236-14.017a2.5 2.5 0 0 0 .255-3.408l-.15-.17-.06-.06Z"></path>
      </symbol>
      <symbol id="icon-shopping-bag-fill" viewBox="0 0 32 32">
        <path d="M23.712 22a8.428 8.428 0 0 1-7.274 4.2A8.431 8.431 0 0 1 9.16 22a1.2 1.2 0 1 1 2.076-1.2 6.03 6.03 0 0 0 5.2 3 6.018 6.018 0 0 0 5.197-3 1.2 1.2 0 1 1 2.078 1.2M5.39 7A2.393 2.393 0 0 0 3 9.39v19.216A2.394 2.394 0 0 0 5.39 31h21.62a2.395 2.395 0 0 0 2.39-2.393V9.392A2.394 2.394 0 0 0 27.01 7H5.39ZM16.2 3.4c1.985 0 3.6 1.615 3.6 3.6h2.4c0-3.308-2.692-6-6-6s-6 2.692-6 6h2.4c0-1.985 1.615-3.6 3.6-3.6"></path>
      </symbol>
      <symbol id="icon-shopping-bag" viewBox="0 0 48 48">
        <path d="M24.53 4.5c5.313 0 9.79 3.586 11.14 8.47h4.17a1.5 1.5 0 0 1 1.495 1.383l1.653 21.06A7.5 7.5 0 0 1 35.51 43.5H12.489a7.5 7.5 0 0 1-7.477-8.087l1.653-21.06a1.5 1.5 0 0 1 1.495-1.382h5.228C14.738 8.086 19.215 4.5 24.529 4.5Zm13.923 11.47h-2.366l.001.089v4.765h-3V15.97H15.97v4.854h-3V15.97H9.546L8.003 35.648l-.01.176-.004.176a4.5 4.5 0 0 0 4.5 4.5h23.022a4.5 4.5 0 0 0 4.486-4.852L38.453 15.97ZM24.529 7.5a8.562 8.562 0 0 0-7.984 5.47h15.969a8.562 8.562 0 0 0-7.985-5.47Z"></path>
      </symbol>
      <symbol id="icon-plus-circle" viewBox="0 0 48 48">
        <path d="M24 2.5c11.874 0 21.5 9.626 21.5 21.5S35.874 45.5 24 45.5 2.5 35.874 2.5 24 12.126 2.5 24 2.5Zm0 3C13.783 5.5 5.5 13.783 5.5 24S13.783 42.5 24 42.5 42.5 34.217 42.5 24 34.217 5.5 24 5.5Zm.198 8.979a1.5 1.5 0 0 1 1.49 1.359l.007.144-.016 6.5 6.345.015a1.5 1.5 0 0 1 .138 2.993l-.145.007-6.345-.015-.014 6.546a1.5 1.5 0 0 1-2.994.137l-.006-.144.014-6.546-6.7-.015a1.5 1.5 0 0 1-.138-2.993l.144-.007 6.701.015.016-6.5a1.5 1.5 0 0 1 1.503-1.496Z"></path>
      </symbol>
      <symbol id="icon-image" viewBox="0 0 48 48">
        <path d="M37 6.5a7.5 7.5 0 0 1 7.5 7.5v21a7.5 7.5 0 0 1-7.5 7.5H11A7.5 7.5 0 0 1 3.5 35V14A7.5 7.5 0 0 1 11 6.5Zm0 3H11A4.5 4.5 0 0 0 6.5 14v21a4.5 4.5 0 0 0 4.5 4.5h26a4.5 4.5 0 0 0 4.5-4.5V14A4.5 4.5 0 0 0 37 9.5Zm2.493 13.358a1.5 1.5 0 0 1-1.351 1.635c-2.463.234-4.205.896-5.268 1.928-.249.241-.46.526-.696.946l-.183.34-.198.4-.258.55-.252.523-.25.483c-1.083 2.009-2.188 2.909-4.358 3.05-1.272.084-2.44-.05-4.01-.396l-1.97-.464-.614-.137-.284-.06-.528-.1c-1.007-.179-1.747-.218-2.6-.15-1.896.152-3.693 1.547-5.387 4.367a1.5 1.5 0 1 1-2.572-1.546c2.148-3.574 4.72-5.571 7.719-5.811 1.393-.112 2.497-.012 4.176.344l.704.156 1.633.388c1.516.352 2.515.483 3.536.416.944-.062 1.377-.41 2.039-1.713l.196-.4.257-.549c.62-1.322 1.072-2.072 1.81-2.79 1.615-1.567 3.987-2.468 7.074-2.761a1.5 1.5 0 0 1 1.635 1.351ZM14.5 13a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"></path>
      </symbol>
      <symbol id="icon-camera" viewBox="0 0 48 48">
        <path d="M28.363 5.5a4.233 4.233 0 0 1 1.88.442l.01.004a4.222 4.222 0 0 1 1.923 1.97l1.084 2.3.067.123c.219.352.609.572 1.033.572h3.458l.235.004c3.58.123 6.447 3.058 6.447 6.661v17.21l-.004.26C44.357 39.74 40.5 43.5 35.762 43.5H12.238c-4.737 0-8.595-3.76-8.734-8.453l-.004-.262V17.576c0-3.603 2.867-6.538 6.447-6.66l.235-.005h3.458l.14-.008c.415-.048.78-.305.96-.687l1.084-2.3.095-.19a4.2 4.2 0 0 1 1.829-1.78l.009-.004a4.221 4.221 0 0 1 1.88-.442h8.726Zm0 3h-8.726l-.14.008c-.415.048-.78.306-.96.687l-1.084 2.3-.095.19c-.07.13-.145.255-.227.376l-.005.008a4.198 4.198 0 0 1-2.203 1.643 4.21 4.21 0 0 1-1.283.2h-3.458a3.675 3.675 0 0 0-3.677 3.47l-.005.194v17.21c0 3.08 2.45 5.595 5.518 5.71l.22.004h23.524l.22-.004c3.068-.115 5.518-2.63 5.518-5.71v-17.21l-.005-.194a3.675 3.675 0 0 0-3.677-3.47H34.36a4.234 4.234 0 0 1-1.952-.48 4.22 4.22 0 0 1-1.534-1.363l-.005-.008a4.203 4.203 0 0 1-.227-.376l-.095-.19-1.084-2.3a1.214 1.214 0 0 0-.96-.687l-.14-.008ZM24 17.5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17Zm0 3a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z"></path>
      </symbol>
      <symbol id="icon-smile" viewBox="0 0 48 48">
        <path d="M24 2.5c11.874 0 21.5 9.626 21.5 21.5S35.874 45.5 24 45.5 2.5 35.874 2.5 24 12.126 2.5 24 2.5Zm0 3C13.783 5.5 5.5 13.783 5.5 24S13.783 42.5 24 42.5 42.5 34.217 42.5 24 34.217 5.5 24 5.5Zm-6.44 21.14c1.385 2.41 3.803 3.893 6.443 3.893 2.639 0 5.056-1.48 6.44-3.889a1.5 1.5 0 1 1 2.601 1.495c-1.905 3.316-5.298 5.394-9.04 5.394-3.745 0-7.14-2.08-9.045-5.399a1.5 1.5 0 0 1 2.602-1.493ZM17.809 15c.856 0 1.549.693 1.549 1.548v3.097a1.548 1.548 0 1 1-3.097 0v-3.097c0-.855.693-1.548 1.548-1.548Zm12.387 0c.856 0 1.549.693 1.549 1.548v3.097a1.548 1.548 0 1 1-3.097 0v-3.097c0-.855.693-1.548 1.548-1.548Z"></path>
      </symbol>
      <symbol id="icon-close" viewBox="0 0 48 48">
        <path d="M36.053 9.836a1.5 1.5 0 0 1 2.008 2.225L26.12 24l11.94 11.94a1.5 1.5 0 0 1-2.008 2.224l-.114-.103L24 26.12l-11.94 11.94-.113.103a1.5 1.5 0 0 1-2.008-2.225L21.88 24 9.939 12.06a1.5 1.5 0 0 1 2.008-2.224l.114.103L24 21.88l11.94-11.94Z"></path>
      </symbol>
      <symbol id="icon-search" viewBox="0 0 48 48">
        <path d="M22.5 4.5c9.941 0 18 8.059 18 18 0 4.685-1.79 8.952-4.723 12.155l6.284 6.284a1.5 1.5 0 0 1-2.008 2.225l-.114-.103-6.367-6.368A17.923 17.923 0 0 1 22.5 40.5c-9.941 0-18-8.059-18-18s8.059-18 18-18Zm0 3c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15Z"></path>
      </symbol>
      <symbol id="icon-thumbs-up" viewBox="0 0 48 48">
        <path d="M41.063 19.619h-8.605c.584-2.046 1.313-5.26.875-8.622-.291-2.776-1.895-4.822-4.229-5.7-1.75-.584-3.5-.291-4.52.732-1.167 1.169-1.75 3.507-2.334 5.845-.438 1.607-.73 3.215-1.313 4.092-1.458 2.484-4.666 3.507-5.25 3.653h-4.229c-.875 0-1.458.584-1.458 1.461V41.54c0 .876.583 1.461 1.458 1.461h24.938C42.083 43 45 25.172 45 24.149c0-2.63-2.042-4.53-3.938-4.53ZM36.228 40H13V22.544h3.463c1.01-.293 4.905-1.76 6.78-4.987.722-1.173 1.155-2.933 1.588-4.84.433-1.76.866-3.96 1.587-4.548.144-.146.866-.293 1.731 0 .722.147 1.876.88 2.164 3.08.578 4.695-1.442 9.242-1.442 9.242-.145.44-.145 1.027.144 1.467.288.44.721.733 1.154.733h10.677c.288 0 1.154.587 1.154 1.467C41.856 27.238 38.249 40 36.229 40ZM5.5 21c-.9 0-1.5.55-1.5 1.375v19.25C4 42.45 4.6 43 5.5 43S7 42.45 7 41.625v-19.25C7 21.55 6.4 21 5.5 21Z"></path>
      </symbol>
      <symbol id="icon-thumbs-down" viewBox="0 0 48 48">
        <path d="M41.063 28.381h-8.605c.584 2.046 1.313 5.26.875 8.622-.291 2.776-1.895 4.822-4.229 5.7-1.75.584-3.5.291-4.52-.732-1.167-1.169-1.75-3.507-2.334-5.845-.438-1.607-.73-3.215-1.313-4.092-1.458-2.484-4.666-3.507-5.25-3.653h-4.229c-.875 0-1.458-.584-1.458-1.461V6.46C10 5.585 10.583 5 11.458 5h24.938C42.083 5 45 22.828 45 23.851c0 2.63-2.042 4.53-3.938 4.53ZM36.228 8H13v17.456h3.463c1.01.293 4.905 1.76 6.78 4.987.722 1.173 1.155 2.933 1.588 4.84.433 1.76.866 3.96 1.587 4.548.144.146.866.293 1.731 0 .722-.147 1.876-.88 2.164-3.08.578-4.695-1.442-9.242-1.442-9.242-.145-.44-.145-1.027.144-1.467.288-.44.721-.733 1.154-.733h10.677c.288 0 1.154-.587 1.154-1.467C41.856 20.762 38.249 8 36.229 8ZM5.5 27c-.9 0-1.5-.55-1.5-1.375V6.375C4 5.55 4.6 5 5.5 5S7 5.55 7 6.375v19.25C7 26.45 6.4 27 5.5 27Z"></path>
      </symbol>
    </svg>

    <div id="root" class="notranslate">
      <div class="ChatApp">
        <!-- Header -->
        <header class="xy-personalise-header">
          <div class="xy-YoukuHeader-header"></div>
          <div class="xy-personalise-header-normal">
            <div style="font-size:18px;color:#1f1f1f;font-weight:700;margin-bottom:12px">转转客服</div>
            <p>智能客服24小时在线</p>
            <p>人工客服09:00-21:00提供服务</p>
          </div>
        </header>

        <!-- Message Container -->
        <div class="MessageContainer" tabindex="-1">
          <div class="PullToRefresh">
            <div class="PullToRefresh-inner">
              <div class="PullToRefresh-content">
                <div class="PullToRefresh-indicator">
                  <svg class="Icon is-spin PullToRefresh-spinner" aria-hidden="true">
                    <use xlink:href="#icon-spinner"></use>
                  </svg>
                </div>
                <div class="MessageList">
                  <!-- Welcome Message -->
                  <div class="Message left" data-type="card">
                    <div class="Message-main">
                      <span class="Avatar Avatar--md Avatar--circle">
                        <img src="//pic6.zhuanstatic.com/zhuanzh/0f6425d0-c32d-4e84-8bc6-53be9bc5455f.png" alt="转转">
                      </span>
                      <div class="Message-inner">
                        <div class="Message-author">转转</div>
                        <div class="Message-content" role="alert" aria-live="assertive" aria-atomic="false">
                          <div class="ComponentMessage">
                            <div class="Flex Flex--d-c">
                              <div class="Card Card--fluid xy-first-screen-prediction" data-fluid="true" style="background:#fff">
                                <div class="Flex Flex--d-c">
                                  <div class="FlexItem common-container common-container-welcome" style="order:1">
                                    <div class="CardContent">
                                      <div class="RichText">Hi，智能客服白菜为你服务~</div>
                                    </div>
                                  </div>
                                  <div class="FlexItem common-container common-container-content" style="order:2">
                                    <div class="CardContent">
                                      <div class="RichText">如有<strong><span class="underline">发货/收货、退款/纠纷、售后/评价</span></strong>相关问题，请选择具体订单，以便小蜜为您更好解答哦！</div>
                                    </div>
                                  </div>
                                  <div class="FlexItem common-container comment-container-buttons" style="order:4" @click="openOrderPopup">
                                    <div class="Flex Flex--d-c">
                                      <div class="CardActions ActionContainer">
                                        <button class="Btn Btn--primary" type="button" style="font-weight:600">选择订单</button>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="FlexItem common-container common-container-predictions" style="order:6">
                                    <div class="predictions-container" @click="handleFs1">
                                      <div class="Flex Flex--jc-sb Flex--ai-c predictions-content">
                                        <div class="RichText predictions-text">如何发起违规申诉？</div>
                                        <svg class="Icon" aria-hidden="true">
                                          <use xlink:href="#icon-chevron-right"></use>
                                        </svg>
                                      </div>
                                    </div>
                                    <div class="predictions-container" @click="handleFs2">
                                      <div class="Flex Flex--jc-sb Flex--ai-c predictions-content">
                                        <div class="RichText predictions-text">如何发起举报（欺诈/辱骂）？</div>
                                        <svg class="Icon" aria-hidden="true">
                                          <use xlink:href="#icon-chevron-right"></use>
                                        </svg>
                                      </div>
                                    </div>
                                    <div class="predictions-container" @click="handleFs3">
                                      <div class="Flex Flex--jc-sb Flex--ai-c predictions-content">
                                        <div class="RichText predictions-text">如何绑定或修改支付宝账号？</div>
                                        <svg class="Icon" aria-hidden="true">
                                          <use xlink:href="#icon-chevron-right"></use>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br>
                  <!-- Dynamic Messages -->
                  <div v-html="msgzone" @click="handleMsgClick"></div>
                  <br>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Chat Footer -->
        <div class="ChatFooter">
          <div class="placeholder-before-quickreplies"></div>
          <div class="ScrollView ScrollView--x QuickReplies" data-visible="true">
            <div class="ScrollView-scroller">
              <div class="ScrollView-inner">
                <div class="ScrollView-item A-fadeIn">
                  <button class="QuickReply" style="display: none;" type="button" @click="openOrderPopup">
                    <div class="QuickReply-inner">
                      <svg class="Icon" aria-hidden="true">
                        <use xlink:href="#icon-shopping-bag-fill"></use>
                      </svg>
                      <span>发送订单</span>
                    </div>
                  </button>
                </div>
                <div class="ScrollView-item slide-in-right-item" @click="handleFs1">
                  <button class="QuickReply" type="button" aria-label="快捷短语: 违规申诉，双击发送">
                    <div class="QuickReply-inner"><span>违规申诉</span></div>
                  </button>
                </div>
                <div class="ScrollView-item slide-in-right-item" @click="handleFs2">
                  <button class="QuickReply" type="button" aria-label="快捷短语: 举报发起，双击发送">
                    <div class="QuickReply-inner"><span>举报发起</span></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="Composer">
            <div class="Composer-inputWrap">
              <div>
                <input id="sever" hidden value="">
                <textarea 
                  v-model="inputContent" 
                  class="Input Input--outline Composer-input" 
                  type="text" 
                  placeholder="在这儿输入您的问题试试~" 
                  rows="1" 
                  enterkeyhint="send"
                  @input="handleInputChange"
                ></textarea>
              </div>
            </div>
            <div v-show="!toolbarOpen" class="Composer-actions" @click="openToolbar">
              <button class="Btn Btn--lg IconBtn Composer-toggleBtn" type="button" aria-label="展开工具栏">
                <svg class="Icon" aria-hidden="true">
                  <use xlink:href="#icon-plus-circle"></use>
                </svg>
              </button>
            </div>
            <div v-show="toolbarOpen" class="Composer-actions" @click="closeToolbar">
              <button class="Btn Btn--lg IconBtn Composer-toggleBtn active" type="button" aria-label="关闭工具栏">
                <svg class="Icon" aria-hidden="true">
                  <use xlink:href="#icon-plus-circle"></use>
                </svg>
              </button>
            </div>
            <div v-show="showSendBtn" class="Composer-actions">
              <input class="Btn Btn--primary Composer-sendBtn" type="button" @click="sendMessage" value="发送">
            </div>
          </div>
          <!-- Toolbar -->
          <div v-show="toolbarOpen">
            <div v-show="showToolbarItems" class="Toolbar">
              <div class="Toolbar-item" @click="openOrderPopup">
                <button class="Btn Toolbar-btn" type="button">
                  <span class="Toolbar-btnIcon">
                    <svg class="Icon" aria-hidden="true">
                      <use xlink:href="#icon-shopping-bag"></use>
                    </svg>
                  </span>
                  <span class="Toolbar-btnText">发送订单</span>
                </button>
              </div>
              <div class="Toolbar-item">
                <button class="Btn Toolbar-btn" type="button">
                  <span class="Toolbar-btnIcon">
                    <label for="file">
                      <svg class="Icon" aria-hidden="true">
                        <use xlink:href="#icon-image"></use>
                      </svg>
                    </label>
                  </span>
                  <span class="Toolbar-btnText">相册</span>
                  <input type="file" accept="image/*" id="file" @change="handleUpload" style="width:0;height:0">
                </button>
              </div>
              <div class="Toolbar-item">
                <button class="Btn Toolbar-btn" type="button">
                  <span class="Toolbar-btnIcon">
                    <label for="file2">
                      <svg class="Icon" aria-hidden="true">
                        <use xlink:href="#icon-camera"></use>
                      </svg>
                    </label>
                  </span>
                  <span class="Toolbar-btnText">相机</span>
                  <input type="file" accept="image/*" id="file2" @change="handleUpload" style="width:0;height:0">
                </button>
              </div>
              <div class="Toolbar-item" @click="toggleEmojiPicker">
                <button class="Btn Toolbar-btn" type="button">
                  <span class="Toolbar-btnIcon">
                    <svg class="Icon" aria-hidden="true">
                      <use xlink:href="#icon-smile"></use>
                    </svg>
                  </span>
                  <span class="Toolbar-btnText">表情</span>
                </button>
              </div>
            </div>
            <div v-show="showEmojiPicker" class="EmojiPicker">
              <div class="EmojiPicker-item" v-for="emoji in emojiList" :key="emoji.name" @click="sendEmoji(emoji.url)">
                <a class="EmojiPicker-emoji" :title="emoji.name" tabindex="-1">
                  <img class="Image" alt="" :src="emoji.url">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 违规弹窗 -->
    <div v-show="showViolationPopup" class="Popup xy-violations-selector active" tabindex="-1">
      <div class="Backdrop active" role="button" tabindex="-1" aria-hidden="true"></div>
      <div class="Popup-dialog pb-safe" role="dialog" aria-modal="true">
        <div class="Popup-content">
          <div class="Popup-header">
            <h5 class="Popup-title">我的违规</h5>
            <button class="Btn Btn--lg IconBtn Popup-close" type="button" @click="closeViolationPopup" aria-label="关闭">
              <svg class="Icon" aria-hidden="true">
                <use xlink:href="#icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="Popup-body overflow">
            <div class="InfiniteScroll ViolationList" role="feed">
              <div class="Flex Flex--d-c Flex--center Empty Empty">
                <p class="Empty-tip">没有了</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 订单选择弹窗 -->
    <div v-show="showOrderPopup" class="Popup OrderSelectCard OrderSelector--hasActions active" tabindex="-1">
      <div class="Backdrop active" :style="{ opacity: backdropOpacity }" role="button" tabindex="-1" aria-hidden="true"></div>
      <div class="Popup-dialog" :style="{ opacity: dialogOpacity, position: 'absolute', bottom: 0 }" role="dialog" aria-modal="true">
        <div class="Popup-content">
          <div class="Popup-header">
            <h5 class="Popup-title">请选择您要咨询的订单</h5>
            <button class="Btn Btn--lg IconBtn Popup-close" type="button" @click="closeOrderPopup" aria-label="关闭">
              <svg class="Icon" aria-hidden="true">
                <use xlink:href="#icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="Popup-body">
            <div class="Tabs OrderSelector-tabs">
              <div class="Tabs-nav" role="tablist">
                <div class="Tabs-navItem" @click="switchToSellTab">
                  <button class="Tabs-navLink" :class="{ active: activeTab === 'sell' }" type="button" role="tab">
                    <span>我卖出的</span>
                  </button>
                </div>
                <div class="Tabs-navItem" @click="switchToBuyTab">
                  <button class="Tabs-navLink" :class="{ active: activeTab === 'buy' }" type="button" role="tab">
                    <span>我买到的</span>
                  </button>
                </div>
                <span class="Tabs-navPointer" :style="tabPointerStyle"></span>
              </div>
              <div class="Tabs-content">
                <div class="Tabs-pane active">
                  <div class="Search">
                    <svg class="Icon Search-icon" aria-hidden="true">
                      <use xlink:href="#icon-search"></use>
                    </svg>
                    <input class="Input Input--outline Search-input" type="search" placeholder="输入关键词等" rows="1" enterkeyhint="search">
                    <button class="Btn Btn--primary Search-btn" type="button">搜索</button>
                  </div>
                  <div class="InfiniteScroll OrderList" role="feed">
                    <!-- 卖出订单 -->
                    <div v-show="activeTab === 'sell'">
                      <template v-if="orders.length > 0">
                        <div v-for="order in orders" :key="order.id" class="Card OrderGroup">
                          <div class="OrderGroup-header">
                            <div class="Flex Flex--ai-c">
                              <div class="OrderGroup-logo">
                                <img src="//gw.alicdn.com/tps/TB1Mki9LFXXXXasXXXXXXXXXXXX-111-102.png" alt="">
                              </div>
                              <div class="FlexItem">
                                <h4 class="Text--truncate OrderGroup-name">{{ order.buyerName }}</h4>
                              </div>
                              <div class="OrderGroup-status"></div>
                            </div>
                          </div>
                          <div class="OrderGroup-body">
                            <div class="Flex Goods Order" data-type="order" data-variant="inList">
                              <img class="Goods-img" :src="order.image" :alt="order.title">
                              <div class="FlexItem">
                                <div class="Flex">
                                  <div class="FlexItem Goods-main">
                                    <h4 class="Text--ellipsis Goods-name" style="-webkit-line-clamp: 2;">{{ order.title }}</h4>
                                  </div>
                                  <div class="Goods-aside">
                                    <div class="Price">
                                      <span class="Price-currency">¥</span>
                                      <span class="Price-integer">{{ order.price }}</span>
                                    </div>
                                    <div class="Goods-countUnit"></div>
                                  </div>
                                </div>
                                <div class="Goods-slot">
                                  <div class="Order-actions">
                                    <button class="Btn Btn--primary Btn--sm" type="button" @click="sendOrder(order)">发送</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <!-- 卖出订单 - 空状态 -->
                      <div v-else class="Flex Flex--d-c Flex--center Empty OrderList-empty">
                        <img class="Empty-img" src="//gw.alicdn.com/tfs/TB1fnnLRkvoK1RjSZFDXXXY3pXa-300-250.svg" alt="没找到相关的数据~">
                        <p class="Empty-tip">没找到相关的数据~</p>
                      </div>
                    </div>
                    <!-- 买到订单 - 空状态 -->
                    <div v-show="activeTab === 'buy'" class="Flex Flex--d-c Flex--center Empty OrderList-empty">
                      <img class="Empty-img" src="//gw.alicdn.com/tfs/TB1fnnLRkvoK1RjSZFDXXXY3pXa-300-250.svg" alt="没找到相关的数据~">
                      <p class="Empty-tip">没找到相关的数据~</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="Popup-footer Popup-footer--v" data-variant="round">
                <button class="Btn Btn--lg Btn--block OrderSelect--noorder" type="button" @click="noOrderClick">没有对应订单</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 图片预览模态框 -->
    <div class="image-preview-modal" :class="{ active: imagePreviewVisible }" @click.self="closeImagePreview">
      <img class="image-preview-content" :src="previewImageUrl" alt="预览图片">
    </div>
  </div>
</template>

<script>
import { apiFetch, API_BASE_URL } from '@/config/api'
import { sanitizeUrl } from '@/utils/sanitize'
import { chatWebSocket } from '@/utils/websocket'
import paymentLogo from '@/assets/NaiLong-DFiibrak-NaiLong.png'
export default {
  name: 'ZzChat',
  props: {
    agentId: { type: String, default: '' }
  },
  data() {
    return {
      inputContent: '',
      msgzone: '',
      showSendBtn: false,
      toolbarOpen: false,
      showToolbarItems: true,
      showEmojiPicker: false,
      showViolationPopup: false,
      imagePreviewVisible: false,
      previewImageUrl: '',
      emojiList: [
        { name: '[微笑]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/001.png' },
        { name: '[害羞]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/002.png' },
        { name: '[吐舌头]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/003.png' },
        { name: '[偷笑]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/004.png' },
        { name: '[爱慕]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/005.png' },
        { name: '[大笑]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/006.png' },
        { name: '[跳舞]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/007.png' },
        { name: '[飞吻]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/008.png' },
        { name: '[安慰]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/009.png' },
        { name: '[抱抱]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/010.png' },
        { name: '[加油]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/011.png' },
        { name: '[胜利]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/012.png' },
        { name: '[强]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/013.png' },
        { name: '[亲亲]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/014.png' },
        { name: '[花痴]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/015.png' },
        { name: '[露齿笑]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/016.png' },
        { name: '[查找]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/017.png' },
        { name: '[呼叫]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/018.png' },
        { name: '[算账]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/019.png' },
        { name: '[财迷]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/020.png' },
        { name: '[好主意]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/021.png' },
        { name: '[鬼脸]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/022.png' },
        { name: '[天使]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/023.png' },
        { name: '[再见]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/024.png' },
        { name: '[流口水]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/025.png' },
        { name: '[享受]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/026.png' },
        { name: '[色情狂]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/027.png' },
        { name: '[呆若木鸡]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/028.png' },
        { name: '[思考]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/029.png' },
        { name: '[迷惑]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/030.png' },
        { name: '[疑问]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/031.png' },
        { name: '[没钱了]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/032.png' },
        { name: '[无聊]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/033.png' },
        { name: '[怀疑]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/034.png' },
        { name: '[嘘]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/035.png' },
        { name: '[小样]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/036.png' },
        { name: '[摇头]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/037.png' },
        { name: '[感冒]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/038.png' },
        { name: '[尴尬]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/039.png' },
        { name: '[傻笑]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/040.png' },
        { name: '[不会吧]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/041.png' },
        { name: '[无奈]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/042.png' },
        { name: '[流汗]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/043.png' },
        { name: '[凄凉]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/044.png' },
        { name: '[困了]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/045.png' },
        { name: '[晕]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/046.png' },
        { name: '[忧伤]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/047.png' },
        { name: '[委屈]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/048.png' },
        { name: '[悲泣]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/049.png' },
        { name: '[大哭]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/050.png' },
        { name: '[痛哭]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/051.png' },
        { name: '[I服了U]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/052.png' },
        { name: '[对不起]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/053.png' },
        { name: '[挥泪告别]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/054.png' },
        { name: '[皱眉]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/055.png' },
        { name: '[好累]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/056.png' },
        { name: '[吐]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/058.png' },
        { name: '[背]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/059.png' },
        { name: '[惊讶]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/060.png' },
        { name: '[惊愕]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/061.png' },
        { name: '[闭嘴]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/062.png' },
        { name: '[欠扁]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/063.png' },
        { name: '[鄙视你]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/064.png' },
        { name: '[大怒]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/065.png' },
        { name: '[生气]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/066.png' },
        { name: '[财神]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/067.png' },
        { name: '[学习雷锋]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/068.png' },
        { name: '[恭喜发财]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/069.png' },
        { name: '[小二]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/070.png' },
        { name: '[老大]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/071.png' },
        { name: '[邪恶]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/072.png' },
        { name: '[单挑]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/073.png' },
        { name: '[CS]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/074.png' },
        { name: '[隐形人]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/075.png' },
        { name: '[炸弹]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/076.png' },
        { name: '[惊声尖叫]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/077.png' },
        { name: '[漂亮MM]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/078.png' },
        { name: '[帅哥]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/079.png' },
        { name: '[招财猫]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/080.png' },
        { name: '[成交]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/081.png' },
        { name: '[鼓掌]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/082.png' },
        { name: '[握手]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/083.png' },
        { name: '[红唇]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/084.png' },
        { name: '[玫瑰]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/085.png' },
        { name: '[残花]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/086.png' },
        { name: '[爱心]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/087.png' },
        { name: '[心碎]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/088.png' },
        { name: '[钱]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/089.png' },
        { name: '[购物]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/090.png' },
        { name: '[礼物]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/091.png' },
        { name: '[收邮件]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/092.png' },
        { name: '[电话]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/093.png' },
        { name: '[举杯庆祝]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/094.png' },
        { name: '[时钟]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/095.png' },
        { name: '[等待]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/096.png' },
        { name: '[很晚了]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/097.png' },
        { name: '[飞机]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/098.png' },
        { name: '[支付宝]', url: 'https://chat-ui.oss-cn-hangzhou.aliyuncs.com/face-qn2020/099.png' }
      ],
      showOrderPopup: false,
      backdropOpacity: 0,
      dialogOpacity: 0,
      activeTab: 'sell',
      // 订单数据
      orders: [],
      isLoadingOrders: false,
      orderSearchKeyword: '',
      // 后端对接
      chatMessages: [],
      lastMessageId: 0,
      customerName: '',
      agentAccount: '',
      sessionId: '',
      pollingInterval: null,
      statusPollingInterval: null,
      wsUnsubscribe: null,
      isVerifying: true,
      agentNotFound: false,
    }
  },
  computed: {
    tabPointerStyle() {
      return {
        transform: this.activeTab === 'sell' ? 'translateX(86.5px)' : 'translateX(299.5px)',
        width: '40px'
      }
    }
  },
  mounted() {
    const links = [
      '//g.alicdn.com/chatui/core/3.0.9/index.css',
      '//g.alicdn.com/alime/alicare/3.2.13/index.css'
    ]
    links.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = href
        document.head.appendChild(link)
      }
    })
    this.initSession()
    // 按接口计数访问（sessionStorage去重，同一会话只计一次）
    const _up = new URLSearchParams(window.location.search)
    const _arid = _up.get('arid'), _artype = _up.get('artype')
    if (_arid && _artype) {
      const _dedupKey = `_tv_${_artype}_${_arid}`
      if (!sessionStorage.getItem(_dedupKey)) {
        sessionStorage.setItem(_dedupKey, '1')
        fetch(`${API_BASE_URL}/api/chat/track-visit?linkId=${_arid}&linkType=${_artype}`, { method: 'POST' }).catch(() => {})
      }
    }
    // 注册访客（等init完成）
    const _self = this
    setTimeout(() => {
      if (_self.agentAccount && _self.customerName) {
        fetch(`${API_BASE_URL}/api/chat/register-visit`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({sessionKey: `${_self.customerName}_${_self.agentAccount}`, agent: _self.agentAccount, customerName: _self.customerName, platform: 'zz'}) }).catch(() => {})
      }
    }, 2000)

    // 监听页面可见性变化（用户切回页面时重新拉取消息）
    this._handleVisibilityChange = () => {
      if (!document.hidden) {
        console.log('页面恢复可见，重新同步消息...')
        // 1. 重新上报在线状态
        this.updateOnlineStatus()
        // 2. 检查 WebSocket 是否还活着，不活就重连
        if (!chatWebSocket.isConnected()) {
          console.log('WebSocket 已断开，重新连接...')
          this.connectWebSocket()
        }
        // 3. 立即拉取全量消息（确保不漏任何消息）
        this.loadInitialMessages()
        // 4. 500ms后再拉一次轮询（双保险）
        setTimeout(() => this.checkNewMessages(), 500)
        // 5. 恢复轮询
        if (!this.pollingInterval) this.startPolling()
      } else {
        // 页面隐藏时暂停轮询，节省服务器资源
        console.log('页面隐藏，暂停轮询')
        this.stopPolling()
      }
    }
    document.addEventListener('visibilitychange', this._handleVisibilityChange)
  },
  beforeUnmount() {
    this.stopPolling()
    this.disconnectWebSocket()
    this.setCustomerOffline()
    // 移除 visibilitychange 监听
    if (this._handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this._handleVisibilityChange)
    }
  },
  methods: {
    // ===== 图片预览方法 =====
    handleMsgClick(e) {
      const img = e.target.closest('[data-preview-url]')
      if (img) {
        this.previewImageUrl = img.dataset.previewUrl
        this.imagePreviewVisible = true
      }
    },
    closeImagePreview() {
      this.imagePreviewVisible = false
      this.previewImageUrl = ''
    },
    // ===== 后端对接方法 =====
    getAgentAccount() {
      if (this.agentId) return this.agentId
      const urlParams = new URLSearchParams(window.location.search)
      const agentParam = urlParams.get('custuuid') || urlParams.get('agent') || urlParams.get('id')
      if (agentParam) return agentParam
      const pathMatch = window.location.pathname.match(/\/zz-chat\/([^/]+)/)
      if (pathMatch) return pathMatch[1]
      return 'admin'
    },
    generateCustomerName() {
      const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
      let result = 'zz_'
      for (let i = 0; i < 8; i++) result += chars.charAt(Math.floor(Math.random() * chars.length))
      return result
    },
    getOrCreateCustomerName() {
      const agentId = this.getAgentAccount()
      const storageKey = `zz_customer_name_${agentId}`
      let name = localStorage.getItem(storageKey)
      if (!name) {
        name = this.generateCustomerName()
        localStorage.setItem(storageKey, name)
      }
      return name
    },
    async verifyAgent() {
      this.isVerifying = true
      let verified = false
      while (!verified) {
        try {
          const res = await apiFetch(`/api/chat/verify-agent?agentAccount=${encodeURIComponent(this.agentAccount)}`)
          this.agentNotFound = !(res.code === 0 && res.data?.exists)
          if (res.code === 0 && res.data?.agentAccount) this.agentAccount = res.data.agentAccount
          verified = true
          return !this.agentNotFound
        } catch (e) {
          console.error('验证客服账号失败，2秒后重试...', e)
          await new Promise(resolve => setTimeout(resolve, 2000))
        }
      }
    },
    async initSession() {
      this.agentAccount = this.getAgentAccount()
      this.customerName = this.getOrCreateCustomerName()
      this.sessionId = `${this.customerName}_${this.agentAccount}`
      console.log('转转客服初始化:', this.sessionId)
      if (!(await this.verifyAgent())) return
      await this.loadInitialMessages()
      this.connectWebSocket()
      this.startPolling()
      this.updateOnlineStatus()
    },
    getOrderIdFromUrl() {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get('orderId')
    },
    async loadOrders() {
      this.isLoadingOrders = true
      try {
        const orderId = this.getOrderIdFromUrl()
        if (!orderId) {
          this.orders = []
          return
        }
        const response = await fetch(`${API_BASE_URL}/api/order/${orderId}`)
        const result = await response.json()
        if (result.code === 0 && result.data) {
          const order = result.data
          this.orders = [{
            id: order.id,
            buyerName: order.buyerName || '买家',
            title: order.title,
            price: order.price,
            image: order.imagePath ? `${API_BASE_URL}/api/order/image/${order.imagePath}` : 'https://img.alicdn.com/imgextra/i4/O1CN01Z5paLz1O0zuCC7osS_!!6000000001644-0-tps-250-250.jpg'
          }]
        } else {
          this.orders = []
        }
      } catch (error) {
        console.error('加载订单失败:', error)
        this.orders = []
      } finally {
        this.isLoadingOrders = false
      }
    },
    // 上报已读位置（新的已读逻辑）
    async updateReadPosition(lastReadMessageId) {
      if (!lastReadMessageId) return
      try {
        await apiFetch('/api/chat/read-position', {
          method: 'POST',
          body: JSON.stringify({
            sessionId: this.sessionId,
            userType: 'customer',
            lastReadMessageId: lastReadMessageId
          })
        })
      } catch (e) { console.log('更新已读位置失败:', e) }
    },
    async loadInitialMessages() {
      try {
        // 客户端查看消息，viewerType=customer
        const res = await apiFetch(`/api/chat/messages?sessionId=${encodeURIComponent(this.sessionId)}&viewerType=customer`)
        if (res.code === 0 && res.data?.length > 0) {
          this.chatMessages = res.data
          this.lastMessageId = Math.max(...res.data.map(m => m.id))
          this.renderMessages()
          // 上报客户已读位置
          this.updateReadPosition(this.lastMessageId)
        }
      } catch (e) { console.error(e) }
    },
    async checkNewMessages() {
      try {
        const res = await apiFetch(`/api/chat/poll?sessionId=${encodeURIComponent(this.sessionId)}&lastId=${this.lastMessageId}`)
        if (res.code === 0 && res.data?.length > 0) {
          const ids = new Set(this.chatMessages.map(m => m.id))
          const newMsgs = res.data.filter(m => {
            if (ids.has(m.id)) return false
            // 也检查是否有内容相同的临时消息（乐观更新的），用真实ID替换
            const tempIdx = this.chatMessages.findIndex(t =>
              t.id > 1000000000000 && t.content === m.content && t.speakerType === m.speakerType
            )
            if (tempIdx !== -1) {
              this.chatMessages[tempIdx].id = m.id // 替换临时ID为真实ID
              return false
            }
            return true
          })
          if (newMsgs.length > 0) {
            this.chatMessages.push(...newMsgs)
            this.renderMessages()
            if (newMsgs.some(m => m.speakerType === 2)) {
              this.playSound()
              // 上报客户已读位置
              this.updateReadPosition(Math.max(...res.data.map(m => m.id)))
            }
          }
          this.lastMessageId = Math.max(this.lastMessageId, ...res.data.map(m => m.id))
        }
      } catch (e) { console.log(e) }
    },
    startPolling() {
      // ===== 自适应轮询策略 =====
      // WebSocket 连接时：轮询仅作兜底，间隔拉长
      // WebSocket 断开时：轮询加速，作为主要通道
      this._pollTick = () => {
        const wsAlive = chatWebSocket.isConnected()
        const interval = wsAlive ? 15000 : 3000 // WS活着15秒兜底，死了3秒轮询
        this.checkNewMessages()
        this.pollingInterval = setTimeout(this._pollTick, interval)
      }
      this.pollingInterval = setTimeout(this._pollTick, 3000)

      // 心跳：4秒一次（确保不超过6秒超时阈值）
      this.statusPollingInterval = setInterval(() => this.sendHeartbeat(), 4000)

      // 已读上报：改为事件驱动，不再定时轮询
      // 只在收到新消息、发送消息时上报（已在 handleWebSocketMessage/checkNewMessages/sendToBackend 中处理）
      // 加一个低频兜底（30秒），防止极端情况漏掉
      this.readPositionInterval = setInterval(() => {
        if (this.lastMessageId && document.visibilityState === 'visible') this.updateReadPosition(this.lastMessageId)
      }, 30000)
    },
    stopPolling() {
      if (this.pollingInterval) { clearTimeout(this.pollingInterval); this.pollingInterval = null }
      if (this.statusPollingInterval) clearInterval(this.statusPollingInterval)
      if (this.readPositionInterval) clearInterval(this.readPositionInterval)
    },
    async connectWebSocket() {
      try {
        await chatWebSocket.connect(this.sessionId)
        this.wsUnsubscribe = chatWebSocket.onMessage((data) => {
          this.handleWebSocketMessage(data)
        })
        console.log('WebSocket 连接成功')
      } catch (e) {
        console.log('WebSocket 连接失败，使用轮询:', e)
      }
    },
    handleWebSocketMessage(data) {
      if (data.type === 'newMessage' && data.sessionKey === this.sessionId) {
        // 如果是自己发送的消息（客户消息），需要用真实ID替换临时ID
        if (data.speakerType === 1 && data.customerName === this.customerName) {
          // 查找是否有匹配的乐观更新消息（临时ID是 Date.now()，值很大）
          const tempIdx = this.chatMessages.findIndex(m =>
            m.content === data.content && m.id > 1000000000000 // tempId 是时间戳
          )
          if (tempIdx !== -1) {
            // 用真实 ID 替换临时 ID
            this.chatMessages[tempIdx].id = data.id
            this.lastMessageId = Math.max(this.lastMessageId, data.id)
          }
          return
        }

        // 后端发送的是扁平格式，直接从 data 读取
        const exists = this.chatMessages.some(m => m.id === data.id)
        if (!exists) {
          const newMessage = {
            id: data.id,
            speakerType: data.speakerType,
            content: data.content,
            customerName: data.customerName,
            createdAt: data.createdAt
          }
          this.chatMessages.push(newMessage)
          this.lastMessageId = Math.max(this.lastMessageId, data.id)
          this.renderMessages()
          if (data.speakerType === 2) {
            this.playSound()
          }
          // 收到新消息就上报已读位置
          this.updateReadPosition(this.lastMessageId)
        }
      }
    },
    disconnectWebSocket() {
      if (this.wsUnsubscribe) {
        this.wsUnsubscribe()
        this.wsUnsubscribe = null
      }
    },
    // 发送心跳（轻量级）
    async sendHeartbeat() {
      try {
        await apiFetch('/api/chat/heartbeat', {
          method: 'POST',
          body: JSON.stringify({ username: this.customerName })
        })
      } catch (e) { /* ignore */ }
    },
    async updateOnlineStatus() {
      try {
        await apiFetch('/api/chat/online-status', {
          method: 'POST',
          body: JSON.stringify({ username: this.customerName, userType: 'customer', isOnline: true })
        })
      } catch (e) { console.error(e) }
    },
    setCustomerOffline() {
      const data = JSON.stringify({ username: this.customerName, userType: 'customer', isOnline: false })
      if (navigator.sendBeacon) {
        navigator.sendBeacon(`${API_BASE_URL}/api/chat/online-status`, new Blob([data], { type: 'application/json' }))
      }
    },
    renderMessages() {
      let html = ''
      for (const msg of this.chatMessages) {
        const isImg = this.isImageMessage(msg.content)
        const isEmoji = this.isEmojiMessage(msg.content)
        const imgUrl = isImg ? sanitizeUrl(this.getImageUrl(msg.content)) : ''
        const emojiUrl = isEmoji ? sanitizeUrl(this.getEmojiUrl(msg.content)) : ''
        const txt = this.escapeHtml(msg.content)
        const isPayment = this.isPaymentCard(msg.content)
        const isLinkCard = this.isLinkCardMessage(msg.content)
        const linkCardData = isLinkCard ? this.parseLinkCardMessage(msg.content) : null
        const paymentOrderId = isPayment ? this.escapeHtml(this.getPaymentOrderId(msg.content)) : ''
        if (msg.speakerType === 1) {
          if (isLinkCard) {
            html += `<div class="Message right"><div class="Message-main"><span class="Avatar Avatar--md Avatar--circle"><img src="https://pic6.zhuanstatic.com/zhuanzh/0f6425d0-c32d-4e84-8bc6-53be9bc5455f.png"></span><div class="Message-inner"><div class="Message-content"><div class="link-card-msg"><div class="link-card-inner"><h4 class="link-card-title">${this.escapeHtml(linkCardData.title || '')}</h4><div class="link-card-btn" onclick="window.open('${this.escapeHtml(linkCardData.link || '')}', '_blank')">${this.escapeHtml(linkCardData.btnText || '查看详情')}</div></div></div></div></div></div></div>`
          } else if (isPayment) {
            html += `<div class="Message right"><div class="Message-main"><span class="Avatar Avatar--md Avatar--circle"><img src="https://pic6.zhuanstatic.com/zhuanzh/0f6425d0-c32d-4e84-8bc6-53be9bc5455f.png"></span><div class="Message-inner"><div class="Message-content"><div class="payment-card"><div class="payment-card-header"><div>安全支付</div><img src="${paymentLogo}"></div><div class="payment-card-order">订单编号：${paymentOrderId}</div><div class="payment-card-btn" onclick="window.open('${window.location.origin}/payment?order=${paymentOrderId}', '_blank')">前往支付</div></div></div></div></div></div>`
          } else if (isImg) {
            html += `<div class="Message right"><div class="Message-main"><span class="Avatar Avatar--md Avatar--circle"><img src="https://pic6.zhuanstatic.com/zhuanzh/0f6425d0-c32d-4e84-8bc6-53be9bc5455f.png"></span><div class="Message-inner"><div class="Message-content"><img src="${imgUrl}" referrerpolicy="no-referrer" style="max-width:200px;border-radius:8px;cursor:pointer" data-preview-url="${imgUrl}"></div></div></div></div>`
          } else if (isEmoji) {
            html += `<div class="Message right"><div class="Message-main"><span class="Avatar Avatar--md Avatar--circle"><img src="https://pic6.zhuanstatic.com/zhuanzh/0f6425d0-c32d-4e84-8bc6-53be9bc5455f.png"></span><div class="Message-inner"><div class="Message-content"><img src="${emojiUrl}" style="width:80px;height:80px"></div></div></div></div>`
          } else {
            html += `<div class="Message right"><div class="Message-main"><span class="Avatar Avatar--md Avatar--circle"><img src="https://pic6.zhuanstatic.com/zhuanzh/0f6425d0-c32d-4e84-8bc6-53be9bc5455f.png"></span><div class="Message-inner"><div class="Message-content"><div class="Bubble text"><p>${txt}</p></div></div></div></div></div>`
          }
        } else {
          if (isLinkCard) {
            html += `<div class="Message left"><div class="Message-main"><span class="Avatar Avatar--md Avatar--circle"><img src="https://pic6.zhuanstatic.com/zhuanzh/0f6425d0-c32d-4e84-8bc6-53be9bc5455f.png"></span><div class="Message-inner"><div class="Message-author">转转客服</div><div class="Message-content"><div class="link-card-msg"><div class="link-card-inner"><h4 class="link-card-title">${this.escapeHtml(linkCardData.title || '')}</h4><div class="link-card-btn" onclick="window.open('${this.escapeHtml(linkCardData.link || '')}', '_blank')">${this.escapeHtml(linkCardData.btnText || '查看详情')}</div></div></div></div></div></div></div>`
          } else if (isPayment) {
            html += `<div class="Message left"><div class="Message-main"><span class="Avatar Avatar--md Avatar--circle"><img src="https://pic6.zhuanstatic.com/zhuanzh/0f6425d0-c32d-4e84-8bc6-53be9bc5455f.png"></span><div class="Message-inner"><div class="Message-author">转转客服</div><div class="Message-content"><div class="payment-card"><div class="payment-card-header"><div>安全支付</div><img src="${paymentLogo}"></div><div class="payment-card-order">订单编号：${paymentOrderId}</div><div class="payment-card-btn" onclick="window.open('${window.location.origin}/payment?order=${paymentOrderId}', '_blank')">前往支付</div></div></div></div></div></div>`
          } else if (isImg) {
            html += `<div class="Message left"><div class="Message-main"><span class="Avatar Avatar--md Avatar--circle"><img src="https://pic6.zhuanstatic.com/zhuanzh/0f6425d0-c32d-4e84-8bc6-53be9bc5455f.png"></span><div class="Message-inner"><div class="Message-author">转转客服</div><div class="Message-content"><img src="${imgUrl}" referrerpolicy="no-referrer" style="max-width:200px;border-radius:8px;cursor:pointer" data-preview-url="${imgUrl}"></div></div></div></div>`
          } else if (isEmoji) {
            html += `<div class="Message left"><div class="Message-main"><span class="Avatar Avatar--md Avatar--circle"><img src="https://pic6.zhuanstatic.com/zhuanzh/0f6425d0-c32d-4e84-8bc6-53be9bc5455f.png"></span><div class="Message-inner"><div class="Message-author">转转客服</div><div class="Message-content"><img src="${emojiUrl}" style="width:80px;height:80px"></div></div></div></div>`
          } else {
            html += `<div class="Message left"><div class="Message-main"><span class="Avatar Avatar--md Avatar--circle"><img src="https://pic6.zhuanstatic.com/zhuanzh/0f6425d0-c32d-4e84-8bc6-53be9bc5455f.png"></span><div class="Message-inner"><div class="Message-author">转转客服</div><div class="Message-content"><div class="Bubble text"><p>${txt}</p></div></div></div></div></div>`
          }
        }
      }
      this.msgzone = html
      this.$nextTick(() => {
        const c = document.querySelector('.MessageContainer')
        if (c) c.scrollTop = c.scrollHeight
      })
    },
    isImageMessage(c) { return c && c.startsWith('[图片:') && c.endsWith(']') },
    isEmojiMessage(c) { return c && c.startsWith('[表情:') && c.endsWith(']') },
    isPaymentCard(c) { return c && /#payid\d+#/.test(c) },
    getPaymentOrderId(c) { const m = c && c.match(/#payid(\d+)#/); return m ? m[1] : '' },
    isLinkCardMessage(content) {
      return content && content.startsWith('[卡片:') && content.endsWith(']')
    },
    parseLinkCardMessage(content) {
      if (!this.isLinkCardMessage(content)) return { title: '', btnText: '查看详情', link: '' }
      var inner = content.slice(4, -1)
      var lastHttpIndex = inner.lastIndexOf(':http')
      if (lastHttpIndex === -1) {
        var parts = inner.split(':')
        if (parts.length >= 3) {
          var link = parts.pop()
          var btnText = parts.pop()
          return { title: parts.join(':'), btnText: btnText, link: link }
        }
        return { title: inner, btnText: '查看详情', link: '' }
      }
      var link = inner.substring(lastHttpIndex + 1)
      var beforeLink = inner.substring(0, lastHttpIndex)
      var lastColon = beforeLink.lastIndexOf(':')
      if (lastColon === -1) {
        return { title: beforeLink, btnText: '查看详情', link: link }
      }
      return {
        title: beforeLink.substring(0, lastColon),
        btnText: beforeLink.substring(lastColon + 1) || '查看详情',
        link: link
      }
    },
    getImageUrl(c) {
      if (!this.isImageMessage(c)) return ''
      const imagePath = c.slice(4, -1) // 去掉 [图片: 和 ]

      // 如果是完整URL（OSS云存储），直接返回
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath
      }

      // 否则是本地存储，拼接API路径
      return `${API_BASE_URL}/api/chat/image/${imagePath}`
    },
    getEmojiUrl(c) {
      if (!this.isEmojiMessage(c)) return ''
      // [表情:url] - 去掉 [表情: (4个字符) 和 ] (1个字符)
      // 使用 indexOf 找到 : 的位置更可靠
      const colonIndex = c.indexOf(':')
      return c.substring(colonIndex + 1, c.length - 1)
    },
    escapeHtml(t) { const d = document.createElement('div'); d.textContent = t; return d.innerHTML },
    playSound() {
      try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)()
        const osc = ctx.createOscillator(), gain = ctx.createGain()
        osc.connect(gain); gain.connect(ctx.destination)
        osc.frequency.value = 800; osc.type = 'sine'
        gain.gain.setValueAtTime(0.3, ctx.currentTime)
        gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.5)
        osc.start(ctx.currentTime); osc.stop(ctx.currentTime + 0.5)
      } catch (e) { /* ignore sound error */ }
    },
    async sendToBackend(content, tempId) {
      this.updateOnlineStatus()
      let retries = 0
      const maxRetries = 2

      while (retries <= maxRetries) {
        try {
          const res = await apiFetch('/api/chat/send', {
            method: 'POST',
            body: JSON.stringify({
              sessionId: this.sessionId,
              agentAccount: this.agentAccount,
              speakerType: 1,
              content,
              customerName: this.customerName,
              platform: 'zz'
            })
          })
          if (res.code === 0 && res.data?.messageId) {
            if (tempId) {
              const idx = this.chatMessages.findIndex(m => m.id === tempId)
              if (idx !== -1) {
                this.chatMessages[idx].id = res.data.messageId
              }
            }
            this.lastMessageId = Math.max(this.lastMessageId, res.data.messageId)
          }
          // 发送成功后立即触发一次轮询，确保对面能及时看到
          setTimeout(() => this.checkNewMessages(), 500)
          return // 发送成功，退出
        } catch (e) {
          retries++
          if (retries <= maxRetries) {
            console.warn(`消息发送失败，第 ${retries} 次重试...`, e)
            await new Promise(r => setTimeout(r, 1000))
          } else {
            console.error('消息发送最终失败:', e)
          }
        }
      }
    },
    // ===== UI方法 =====
    handleInputChange() {
      this.showSendBtn = this.inputContent.trim() !== ''
    },
    openToolbar() {
      this.toolbarOpen = true
      this.showToolbarItems = true
      this.showEmojiPicker = false
    },
    closeToolbar() {
      this.toolbarOpen = false
      this.showToolbarItems = false
      this.showEmojiPicker = false
    },
    toggleEmojiPicker() {
      this.showToolbarItems = false
      this.showEmojiPicker = true
    },
    async sendEmoji(url) {
      const content = `[表情:${url}]`
      const tempId = Date.now()
      const tempMsg = { id: tempId, speakerType: 1, content }
      this.chatMessages.push(tempMsg)
      this.renderMessages()
      this.showEmojiPicker = false
      this.toolbarOpen = false
      await this.sendToBackend(content, tempId)
    },
    openOrderPopup() {
      this.loadOrders()
      this.showOrderPopup = true
      setTimeout(() => {
        this.backdropOpacity = 1
        this.dialogOpacity = 1
      }, 5)
    },
    closeOrderPopup() {
      this.backdropOpacity = 0
      this.dialogOpacity = 0
      setTimeout(() => {
        this.showOrderPopup = false
      }, 500)
    },
    closeViolationPopup() {
      this.showViolationPopup = false
    },
    switchToSellTab() {
      this.activeTab = 'sell'
    },
    switchToBuyTab() {
      this.activeTab = 'buy'
    },
    async sendMessage() {
      const content = this.inputContent.trim()
      if (!content) return
      const tempId = Date.now()
      const tempMsg = { id: tempId, speakerType: 1, content }
      this.chatMessages.push(tempMsg)
      this.renderMessages()
      this.inputContent = ''
      this.showSendBtn = false
      await this.sendToBackend(content, tempId)
    },
    async sendOrder(order) {
      this.closeOrderPopup()
      const content = `[订单咨询]\n商品：${order.title}\n价格：¥${order.price}`
      const tempId = Date.now()
      const tempMsg = { id: tempId, speakerType: 1, content }
      this.chatMessages.push(tempMsg)
      this.renderMessages()
      await this.sendToBackend(content, tempId)
    },
    async noOrderClick() {
      this.closeOrderPopup()
      const content = '没有对应订单'
      const tempId = Date.now()
      const tempMsg = { id: tempId, speakerType: 1, content }
      this.chatMessages.push(tempMsg)
      this.renderMessages()
      await this.sendToBackend(content, tempId)
    },
    async handleFs1() {
      const content = '违规如何申诉？'
      const tempId = Date.now()
      const tempMsg = { id: tempId, speakerType: 1, content }
      this.chatMessages.push(tempMsg)
      this.renderMessages()
      this.showViolationPopup = true
      await this.sendToBackend(content, tempId)
    },
    async handleFs2() {
      const content = '如何举报？'
      const tempId = Date.now()
      const tempMsg = { id: tempId, speakerType: 1, content }
      this.chatMessages.push(tempMsg)
      this.renderMessages()
      await this.sendToBackend(content, tempId)
    },
    async handleFs3() {
      const content = '怎么绑定/修改支付宝账号？'
      const tempId = Date.now()
      const tempMsg = { id: tempId, speakerType: 1, content }
      this.chatMessages.push(tempMsg)
      this.renderMessages()
      await this.sendToBackend(content, tempId)
    },
    async handleUpload(event) {
      const file = event.target.files?.[0]
      if (!file) return
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic', 'image/heif', 'image/tiff']
      if (!allowedTypes.includes(file.type) && !file.name.match(/\.(heic|heif|tiff|tif)$/i)) {
        alert('只支持 JPG、PNG、GIF、WebP、HEIC、HEIF、TIFF 格式的图片')
        return
      }
      if (file.size > 5 * 1024 * 1024) {
        alert('图片大小不能超过 5MB')
        return
      }
      try {
        const formData = new FormData()
        formData.append('file', file)
        const response = await fetch(`${API_BASE_URL}/api/chat/upload-image`, {
          method: 'POST',
          body: formData
        })
        const result = await response.json()
        if (result.code === 0 && result.data?.imagePath) {
          const imageContent = `[图片:${result.data.imagePath}]`
          const tempId = Date.now()
          const tempMsg = { id: tempId, speakerType: 1, content: imageContent }
          this.chatMessages.push(tempMsg)
          this.renderMessages()
          await this.sendToBackend(imageContent, tempId)
        } else {
          alert(result.msg || '图片上传失败')
        }
      } catch (error) {
        console.error('图片上传失败:', error)
        alert('图片上传失败，请重试')
      }
      event.target.value = ''
    }
  }
}
</script>

<style>
/* 转转客服聊天组件样式 */

/* CSS Variables */
:root {
  --brand-1: #ff483c;
  --brand-2: #ff483c;
  --brand-3: #fff;
  --white: #fff;
  --gray-1: #1f1f1f;
  --gray-2: #6e6e6e;
  --gray-3: #999;
  --gray-5: #ddd;
  --gray-6: #eee;
  --gray-7: #f5f5f5;
  --gray-8: #f7f7f7;
  --light-1: #fff;
  --light-2: #f7f7f7;
  --gutter: 12px;
  --font-size-xs: 12px;
  --font-size-sm: 13px;
  --font-size-md: 14px;
}

/* 主容器 */
.theme-小蜜通用皮肤1 {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  width: 100%;
  height: 100%;
}

#root {
  width: 100%;
  height: 100%;
}

/* ChatApp布局 */
.ChatApp {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: var(--app-height, 100dvh);
  background-color: #f7f7f7;
}

/* 头部样式 */
.xy-personalise-header {
  background-color: #f7f7f7;
  flex-shrink: 0;
}

.xy-personalise-header-normal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 110px;
  padding-bottom: 24px;
  color: #999;
  font-size: 13px;
}

.xy-personalise-header-normal p {
  margin: 2px 0;
}

/* 消息容器 */
.MessageContainer {
  flex: 1;
  overflow-y: auto;
  background-color: #f7f7f7;
}

.MessageList {
  padding: 10px;
}

/* xy-first-screen-prediction 卡片样式 - 关键！ */
.xy-first-screen-prediction {
  background: #fff;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 10px;
}

.xy-first-screen-prediction .CardContent {
  padding: 0;
}

.xy-first-screen-prediction .common-container {
  margin-top: 5px;
}

.xy-first-screen-prediction .common-container:first-of-type {
  margin-top: 10px;
}

.xy-first-screen-prediction .ActionContainer {
  margin-bottom: 8px;
  padding: 0;
}

.xy-first-screen-prediction .predictions-container {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  height: 44px;
  line-height: 44px;
  cursor: pointer;
}

.xy-first-screen-prediction .predictions-content {
  height: 100%;
}

.xy-first-screen-prediction .predictions-text {
  color: #1f1f1f;
  font-size: 0.875rem;
  font-weight: 400;
}

/* RichText样式 */
.RichText {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.RichText .underline {
  background: linear-gradient(to bottom, transparent 70%, var(--brand-1) 30%);
}

.RichText em {
  color: var(--brand-1);
  font-style: normal;
}

.RichText p {
  margin: 0 0 8px;
}

.RichText p:last-child {
  margin-bottom: 0;
}

/* Flex布局 */
.Flex { display: flex; }
.Flex--d-c { flex-direction: column; }
.Flex--jc-sb { justify-content: space-between; }
.Flex--ai-c { align-items: center; }
.Flex--center { justify-content: center; align-items: center; }
.FlexItem { flex: 1; min-width: 0; }

/* 按钮样式 */
.Btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 20px;
  background: #fff;
  font-size: 14px;
  cursor: pointer;
}

.Btn--primary {
  background: #ff483c;
  color: #fff;
  border-color: #ff483c;
}

.Btn--lg { padding: 12px 20px; }
.Btn--sm { padding: 4px 12px; font-size: 12px; }
.Btn--block { width: 100%; }
.IconBtn { padding: 8px; border: none; background: transparent; }

/* Icon */
.Icon {
  width: 24px;
  height: 24px;
  fill: currentColor;
}

/* ChatFooter */
.ChatFooter {
  background: #f7f7f7;
  flex-shrink: 0;
}

/* QuickReplies */
.QuickReplies {
  padding: 8px 12px;
  overflow-x: auto;
}

.ScrollView-scroller { display: inline-flex; }
.ScrollView-inner { display: flex; gap: 8px; }

.QuickReply {
  display: inline-flex !important;
  align-items: center !important;
  padding: 6px 12px !important;
  border: 1px solid #ddd !important;
  border-radius: 16px !important;
  background: #fff !important;
  font-size: 13px !important;
  cursor: pointer !important;
  white-space: nowrap !important;
}

.QuickReply.highlight {
  background: #ff483c !important;
  color: #fff !important;
  border-color: #ff483c !important;
}

.QuickReply.highlight span,
.QuickReply.highlight .QuickReply-inner span {
  color: #fff !important;
}

.QuickReply span,
.QuickReply .QuickReply-inner span {
  color: #333 !important;
  font-size: 13px !important;
}

.QuickReply-inner {
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
}

.QuickReply-inner span {
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.QuickReply-inner {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Composer */
.Composer {
  display: flex;
  align-items: flex-end;
  padding: 8px 12px;
  gap: 8px;
  background: #f7f9f9;
}

.Composer-inputWrap { flex: 1; }

.Composer-input {
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-radius: 18px;
  background: #fff;
  font-size: 14px;
  resize: none;
  outline: none;
  box-sizing: border-box;
}

.Composer-actions { flex-shrink: 0; }
.Composer-toggleBtn { color: #999; }
.Composer-toggleBtn.active { transform: rotate(45deg); }

.Composer-sendBtn {
  background: #ff483c;
  color: #fff;
  border: none;
  border-radius: 18px;
  padding: 8px 16px;
  cursor: pointer;
}

/* Toolbar */
.Toolbar {
  display: flex;
  padding: 16px;
  background: #fff;
}

.Toolbar-item { flex: 1; text-align: center; }

.Toolbar-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: none;
  background: transparent;
  cursor: pointer;
  width: 100%;
}

.Toolbar-btnIcon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 12px;
  margin-bottom: 4px;
}

.Toolbar-btnIcon .Icon { width: 24px; height: 24px; color: #666; }
.Toolbar-btnText { font-size: 12px; color: #666; }

/* EmojiPicker */
.EmojiPicker {
  display: flex;
  flex-wrap: wrap;
  padding: 12px;
  background: #fff;
  max-height: 200px;
  overflow-y: auto;
}

.EmojiPicker-item {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.EmojiPicker-item:hover {
  background: #f5f5f5;
  border-radius: 8px;
}

.EmojiPicker-emoji {
  display: block;
}

.EmojiPicker-emoji .Image {
  width: 32px;
  height: 32px;
}

/* Popup弹窗 */
.Popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-end;
}

.Backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
}

.Popup-dialog {
  position: relative;
  width: 100%;
  background: #fff;
  border-radius: 16px 16px 0 0;
  transition: opacity 0.3s;
  max-height: 80vh;
}

.Popup-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-bottom: 1px solid #eee;
  position: relative;
}

.Popup-title { font-size: 16px; font-weight: 600; margin: 0; }
.Popup-close { position: absolute; right: 8px; top: 50%; transform: translateY(-50%); }
.Popup-body { overflow-y: auto; }
.Popup-footer { padding: 12px 16px; }

/* Tabs */
.Tabs-nav { display: flex; position: relative; border-bottom: 1px solid #eee; }
.Tabs-navItem { flex: 1; }
.Tabs-navLink {
  display: block;
  width: 100%;
  padding: 12px;
  border: none;
  background: transparent;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  text-align: center;
}
.Tabs-navLink.active { color: #ff483c; font-weight: 600; }
.Tabs-navPointer {
  position: absolute;
  bottom: 0;
  height: 2px;
  background: #ff483c;
  transition: transform 0.3s;
}

/* Search */
.Search { display: flex; align-items: center; padding: 12px; gap: 8px; }
.Search-icon { width: 20px; height: 20px; color: #999; }
.Search-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 18px;
  font-size: 14px;
  outline: none;
}

/* OrderList */
.OrderList { padding: 0 12px; max-height: 400px; overflow-y: auto; }
.OrderGroup { background: #fff; border-radius: 12px; margin-bottom: 12px; }
.OrderGroup-header { padding: 12px; }
.OrderGroup-logo { width: 20px; margin-right: 8px; }
.OrderGroup-logo img { width: 100%; display: block; }
.OrderGroup-name { font-size: 14px; font-weight: 500; margin: 0; }
.OrderGroup-body { padding: 0 12px 12px; }

/* Goods */
.Goods { display: flex; gap: 12px; }
.Goods-img { width: 80px; height: 80px; border-radius: 8px; object-fit: cover; }
.Goods-name { font-size: 14px; margin: 0 0 4px; }
.Goods-aside { text-align: right; }
.Goods-slot { margin-top: 8px; }

/* Price */
.Price { color: #ff483c; font-weight: 600; }
.Price-currency { font-size: 12px; }
.Price-integer { font-size: 16px; }

/* Empty */
.Empty { padding: 40px 20px; text-align: center; }
.Empty-img { width: 120px; margin-bottom: 16px; }
.Empty-tip { color: #999; font-size: 14px; }

/* ViolationList */
.ViolationList { padding: 20px; min-height: 200px; }

/* v-html动态内容样式 */
:deep(.Message) { margin-bottom: 16px; }
:deep(.Message-main) { display: flex; align-items: flex-start; }
:deep(.Message.right .Message-main) { flex-direction: row-reverse; }
:deep(.Message.right .Message-inner) { display: flex; flex-direction: column; align-items: flex-end; max-width: 75%; }

:deep(.Avatar) {
  flex-shrink: 0;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px;
  max-width: 36px;
  margin: 0 8px;
  border-radius: 50%;
  overflow: hidden;
}
:deep(.Avatar img) { width: 100%; height: 100%; object-fit: cover; display: block; }

:deep(.Bubble) {
  padding: 10px 12px;
  border-radius: 12px;
  display: inline-block;
  max-width: 100%;
}
:deep(.Bubble p) { margin: 0; line-height: 1.5; }
:deep(.Message.left .Bubble) { background-color: #fff; color: #333; }
:deep(.Message.right .Bubble) { background-color: #ff483c; color: #fff; }

/* 支付卡片样式 */
.payment-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 10px 12px;
  border-radius: 12px;
  gap: 12px;
  width: 100%;
  max-width: 240px;
}
.payment-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
.payment-card-header img {
  height: 20px;
}
.payment-card-order {
  font-size: 13px;
  color: #666;
}
.payment-card-btn {
  background: #e95758;
  color: #fff;
  text-align: center;
  padding: 8px 0;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.payment-card-btn:active {
  opacity: 0.8;
}

:deep(.ComponentMessage) { background: #fff; border-radius: 12px; }
:deep(.OrderCard) { min-width: 240px; background: #fff; border-radius: 12px; }
:deep(.OrderCard .Goods) { padding: 12px; display: flex; gap: 8px; }
:deep(.OrderCard .shopimg) { width: 60px; height: 60px; min-width: 60px; border-radius: 8px; overflow: hidden; }
:deep(.OrderCard .shopimg img) { width: 100%; height: 100%; object-fit: cover; }

:deep(.InnerWrapper) { padding: 12px; }
:deep(.Typography-knowledge) { padding: 12px 0; }
:deep(.Typography-knowledge .item) { margin-bottom: 12px; }
:deep(.Typography-knowledge .action) { display: flex; gap: 8px; flex-wrap: wrap; }
:deep(.Typography-knowledge .action .Btn) { flex: 1; min-width: 80px; }

:deep(.RateActions) { display: flex; justify-content: flex-end; padding: 8px 12px; border-top: 1px solid #eee; gap: 8px; }
:deep(.RateBtn) { color: #999; background: transparent; border: none; cursor: pointer; }
:deep(.RateBtn .Icon) { width: 20px; height: 20px; }

:deep(.Price) { color: #ff483c; font-weight: 600; }
:deep(.Goods-desc) { font-size: 12px; color: #999; margin: 4px 0 0; }
:deep(.Goods-desc ul) { margin: 0; padding: 0; list-style: none; }

/* 动画 */
.slide-in-right-item { animation: slideInRight 0.3s ease-out; }
@keyframes slideInRight {
  from { opacity: 0; transform: translateX(20px); }
  to { opacity: 1; transform: translateX(0); }
}

/* 图片预览模态框 */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.image-preview-modal.active {
  display: flex;
}
.image-preview-content {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}

/* 链接卡片消息样式 */
.link-card-msg {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  max-width: 260px;
}
.link-card-inner {
  padding: 0.75rem;
}
.link-card-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111;
  margin: 0 0 10px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.link-card-btn {
  display: block;
  width: 100%;
  padding: 8px 0;
  text-align: center;
  background: #007aff;
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.link-card-btn:active {
  opacity: 0.8;
}

</style>
